import { HomeRounded } from '@mui/icons-material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { resetFlatFileState } from '../../../redux/FlatFile/FlatFileStateActions';
import { resetAllStates } from '../../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import { areNestedObjectsEqual } from '../../CommonFunctions/CommonFunctions';
import { ignoreKeys } from './constants';
import silzilaNewLogo from '../../../assets/new_silzilaLogo.svg';

const HomeIcon = ({
  // state
  xprops,
  from,
  showSaveWarning,
  disableEdit,

  // methods
  setSaveFromHomeIcon,
  setSaveModal,
  currPlaybook,
  setOpenSaveCalculationDialogFromHomeIcon,
}: {
  xprops: any;
  from: string;
  showSaveWarning: boolean;
  disableEdit?: boolean;

  currPlaybook: () => any;
  setSaveModal: (value: boolean) => void;
  setSaveFromHomeIcon: (value: boolean) => void;
  setOpenSaveCalculationDialogFromHomeIcon: (value: boolean) => void;
}) => {
  const { playbookState } = useSelector((state: RootState) => ({
    playbookState: state.playBookState,
  }));

  const dispatch = useDispatch<any>();

  const navigate = useNavigate();

  const getHomeIcon = () => {
    switch (from) {
      case 'dataHome':
        return (
          <div className="menuHomeIcon">
            <HomeRounded fontSize="large" sx={{ color: '#2bb9bb' }} />
          </div>
        );
      case 'dataSet':
        return (
          <div
            className="menuHomeIcon"
            onClick={() => {
              navigate('/');
            }}
          >
            <HomeRounded fontSize="large" sx={{ color: '#2bb9bb' }} />
          </div>
        );
      case 'fileUpload':
      case 'editFlatFile':
      case 'saveFlaFile':
        return (
          <div
            className="menuHomeIcon"
            onClick={() => {
              dispatch(resetFlatFileState());
              navigate('/');
            }}
          >
            <HomeRounded fontSize="large" sx={{ color: '#2bb9bb' }} />
          </div>
        );
      case 'dataViewer':
        return (
          <div
            className="menuHomeIcon"
            onClick={() => {
              if (showSaveWarning || playbookState.playBookUid === null) {
                setSaveFromHomeIcon(true);
                setSaveModal(true);
              } else {
                dispatch(resetAllStates());
                navigate('/');
              }
            }}
          >
            <HomeRounded fontSize="large" sx={{ color: '#2bb9bb' }} />
          </div>
        );
    }
  };

  return (
    <div onMouseOver={() => xprops.setOpen(false)} onMouseLeave={() => xprops.setOpen(true)}>
      {(xprops.open && from !== 'dataHome') ||
      from === 'fileUpload' ||
      from === 'editFlatFile' ||
      from === 'saveFlaFile' ? (
        <>{getHomeIcon()}</>
      ) : (
        <>
          <div
            onClick={() => {
              if (from === 'dataViewer' && !disableEdit) {
                // if (showSaveWarning || playBookState.playBookUid === null) {
                if (
                  !areNestedObjectsEqual(
                    sessionStorage.getItem(`pb_id_${playbookState.playBookUid}`) || '',
                    JSON.stringify(currPlaybook()),
                    ignoreKeys,
                  )
                ) {
                  setSaveFromHomeIcon(true);
                  setOpenSaveCalculationDialogFromHomeIcon(true);
                } else {
                  sessionStorage.removeItem(`pb_id_${playbookState.playBookUid}`);
                  dispatch(resetAllStates());
                  navigate('/');
                }
                // }
              } else {
                dispatch(resetAllStates());
                navigate('/');
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            <img
              src={silzilaNewLogo}
              style={{
                // height: "100%",
                height: '1.625rem',
                // width: "3rem",
                width: '1.625rem',
                // padding: "4px 4px 4px 6px",
                // margin: "4px 0px 0px 2px",
              }}
              alt="Silzila Home"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default HomeIcon;
